/** Synthetic agreement option — not stored in shelter settings. */
const EQUIPMENT_RENTAL_NO_AGREEMENT_ID = '__equipment_rental_no_agreement__';

export { EQUIPMENT_RENTAL_NO_AGREEMENT_ID };
